import { routeItem } from '@/types';
import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

const DashboardPage = lazy(() => import('./pages/DashboardPage'));

export const dashboardRoutes: routeItem[] = [
  {
    path: 'dashboard',
    index: true,
    element: <DashboardPage />
  },
];